/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';
import { Modal } from '@madeeasy/universal-login';
import { Roboto } from 'next/font/google';
import { getCurrentOrganization, getOrganizationPropertiesByHost } from '../../../utils/helpers';
import HeaderTop from './HeaderTop';
import LoginButton from './LoginButton';
import { HeaderContext } from '../../../contexts/headerContext';
import Main from './MainMenu';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['300', '400', '500', '700', '900'],
  variable: '--font-roboto',
});

export default function Header({ menuItems }) {
  const { showLogin, setShowLogin } = useContext(HeaderContext);

  const { miscellaneousData } = useMiscellaneousData();
  let organizationProperties;
  if (miscellaneousData?.hostname) {
    organizationProperties = getOrganizationPropertiesByHost(miscellaneousData.hostname);
  } else {
    organizationProperties = getCurrentOrganization();
  }
  const isNextIas = organizationProperties?.organizationName === 'nextias';

  function toggleModal() {
    setShowLogin(false);
  }

  if (!menuItems) return null;

  return (

    isNextIas ? (
      <div className={`xl:max-w-[1420px] lg:max-w-[960px] container mx-auto flex xl:flex-col xl:items-center ${roboto.className} ${isNextIas ? '' : 'xl:max-w-[1320px] lg:max-w-[960px] mx-auto'}`}>
        <HeaderTop topMenuItems={menuItems} />
        <div />
        <div className="w-full flex justify-center order-first xl:order-last">
          <div className={`flex container items-center justify-between px-2 ${isNextIas ? 'py-2 xl:px-[18px]' : 'pt-0 pb-2 xl:pb-2'}`}>
            <div className="w-auto text-center font-bold text-lg text-white">
              {/* <Link href={`${isNextIas ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`}>
                <Image width={isNextIas ? 500 : 80} height={isNextIas ? 500 : 80} src={isNextIas ? 'https://cdnstatic.nextias.com/cdn-cgi/image/format=auto/assets/images/logo/next-ias.png' : 'https://cdnstatic.madeeasyprime.com/resources/logos/MEP-Logo-new-1745227399331.svg'} alt="logo" className={`${isNextIas ? 'w-[146px] h-8' : ''}`} />
              </Link> */}
              <Link
                href={`${isNextIas ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`}
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `${isNextIas ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`;
                }}
              >
                <Image width={isNextIas ? 500 : 80} height={isNextIas ? 500 : 80} src={isNextIas ? 'https://cdnstatic.nextias.com/cdn-cgi/image/format=auto/assets/images/logo/next-ias.png' : 'https://cdnstatic.madeeasyprime.com/resources/logos/MEP-Logo-new-1745227399331.svg'} alt="logo" className={`${isNextIas ? 'w-[156px] h-8' : ''}`} />
              </Link>
            </div>
            <div className="hidden xl:block">
              <Main list={menuItems.main_header} />
            </div>
            <div className="hidden xl:inline-block">
              <LoginButton />
            </div>

            {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
          </div>
        </div>
      </div>

    ) : (
      <div className={`xl:max-w-[1320px] lg:max-w-[960px] container mx-auto grid grid-cols-[auto_1fr] gap-4 px-4 py-2 xl:px-[18px] items-center ${roboto.className}`}>
        <div className="w-auto text-center font-bold text-lg text-white">
          <Link
            href={`https://${miscellaneousData?.hostname}`}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = `https://${miscellaneousData?.hostname}`;
            }}
          >
            <Image width={80} height={80} className="xl:w-[80px] md:w-[60px] w-[40px]" src="https://cdnstatic.madeeasyprime.com/resources/logos/MEP-Logo-new-1745227399331.svg" alt="logo" />
          </Link>
        </div>
        <div>
          <HeaderTop topMenuItems={menuItems} />
          <div className="hidden xl:flex items-center justify-center">
            <Main list={menuItems.main_header} />
            <div className="ml-4">
              <LoginButton />
            </div>
          </div>
          {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
        </div>
      </div>
    )
  );
}

Header.propTypes = {
  menuItems: PropTypes.object,
};
